// extracted by mini-css-extract-plugin
module.exports = {"header":"header-1ijZ_vLb","header_bar":"header_bar-R_CRmEjM clearfix","user":"user-1KhRVDbP","search":"search-1Bbxbv2O","box":"box-2bJEQmzB"};